import {
  DeferredPostStatus,
  FacebookPage,
  GooglePage,
  InstagramPage, LinkedInPage,
  NetworkType,
  PostContent,
  Tag
} from '@3m5/sm_publish-frontend-api/models'
import { Message } from './messageTypes'
import { JSX } from 'react'

export enum Languages {
  de = 'de',
  en = 'en',
  es = 'es',
  it = 'it',
}

export enum DisplayMode {
  popUp = 'popUp',
  newScreen = 'newScreen',
  additional = 'additional',
}

export enum UserScreen {
  dashboard = 'dashboard',
  facebook = 'facebook',
  statistics = 'statistics',
  topics = 'topics',
  help = 'help'
}

export enum EditorScreen {
  dashboard = 'dashboard',
  statistics = 'statistics',
  accounts = 'accounts',
  images = 'images',
  topics = 'topics',
  quiz = 'quiz',
  imprint = 'imprint',
  help = 'help',
  announcement = 'announcement',
}

export enum AdminScreen {
  accounts = 'accounts',
  unlinkedPages = 'unlinkedPages'
}

export enum ProfileScreen {
  settings = 'settings',
  privacy = 'privacy',
  logout = 'logout'
}

export interface SocialMediaNetwork {
  [key: string]: boolean
}

export interface SocialNetworkLicensePermissions {
  [key: string]: boolean
}

export interface NetworkPage {
  facebookPage?: FacebookPage
  instagramPage?: InstagramPage
  googleMyBusinessPage?: GooglePage
  linkedInPage?: LinkedInPage
}

export enum ViewEnum {
  overview = 'overview',
  template = 'template',
  templateDetails = 'templateDetails',
  templateUser = 'templateUser',
  calendar = 'calendar',
  preview = 'preview',
  single = 'single'
}

export enum ScreenEnum {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}

export enum PostTypeEnum {
  PHOTO = 'PHOTO',
  LINK = 'LINK',
  VIDEO = 'VIDEO',
  MESSAGE = 'MESSAGE',
}

export interface PostingTemplate {
  content: PostContent
  entityId?: string
  pagePostId?: string
  socialMediaNetwork: SocialMediaNetwork
  licensePermissions?: SocialNetworkLicensePermissions
  manipulateLinks?: boolean
  aboTopicId?: string
  tags?: Tag[]
  postStart?: Date
  postEnd?: Date
  status?: DeferredPostStatus
  addHashtag?: boolean
  postTemplateId?: string
  sortPopular?: number
  sortNew?: number
  deferredPostId?: string
}

export enum TemplateType {
  suggestion = 'suggestion',
  posting = 'posting',
  newPost = 'newPost',
}

export type Navigation = {
  label: string
  value: string
  key: string
  changeTo?: any
  icon?: JSX.Element
}

export type DeletePost = {
  socialMediaNetwork: NetworkType
  networkPostId: string
}

export interface ActionCall {
  type: string
  id?: string
  network?: NetworkType
  inProgress?: boolean
  status?: 'pending' | 'success' | 'failed'
  message?: Message
  error?: any
}

export enum PreviewFormat {
  square = 'square',
  origin = 'origin',
}

export interface GeneralPostingOptions {
  allowLinkParsing?: boolean
  allowTemplateEdit?: boolean
  allowLinkIndividualisation?: boolean
  allowIndividualHashtags?: boolean
  showLinkIndividualisation?: boolean
  showIndividualHashtags?: boolean
  allowTags?: boolean
  allowImageUpload?: boolean
  allowVideoUpload?: boolean
  templateSelection?: boolean
  showAsPopUp?: boolean
  showPreview?: boolean
  maxCharacters?: number
  useMediaGallery?: boolean
  previewFormat?: PreviewFormat
  allowIndividualizeUserLinks?: boolean
}

export interface GeneralOptions {
  instagramNumberOfPosts: 9 | 24
}

export interface RegistrationJsonField {
  name: string
  inputType?: string
  type?: string
  label?: string
  title?: string
  pattern?: string | null
  value?: string
  color?: string
  info?: string
  required?: boolean
  equals?: string
  ignore?: boolean
  option?: Option[]
}

export interface RegistrationFailedJsonFields {
  headline: string
  successHeader: string
  success: string
  fields: RegistrationJsonField[]
}

export interface RegistrationCustomerData {
  headline: string
  reRegister?: string
  success: string
  error: string
  usernameAlreadyExists: string
  fields: RegistrationJsonField[]
  failed?: RegistrationFailedJsonFields
}

export interface Option {
  label: string
  value: string
  color?: string
}

